import { useAuthorization, useApi } from '../../../utils/hooks';
import { DefaultLayout as Layout } from '../../../layouts/Default/DefaultLayout';
import { useStoreContext } from '../../../store/store';
import { TileLink } from '../../../components/ui/TileLink/TileLink';
import { faBolt, faFileWaveform, faPalette } from '@fortawesome/free-solid-svg-icons';
import { Helpers } from '../../../utils/helpers/Helpers';
import { IAuthToken } from '../../../utils/constants/interfaces';
import { StorageService } from '../../../utils/helpers/StorageService';
import styles from './DevToolsHomePage.module.css';

export const DevToolsHomePage = () => {
  useAuthorization();
  const { user, actions, dispatch } = useStoreContext();
  const api = useApi();

  const refreshToken = async () => {
    try {
      const apiResponse = await api.get<string>('/auth/refresh');
      if (apiResponse.isSuccessStatusCode && apiResponse.response) {
        const token: string = apiResponse.response;
        const authToken: IAuthToken = Helpers.decodeAuthToken(token);
        dispatch(actions.setUserAuthToken(authToken));
        StorageService.setAuthToken(token);
      }
    } catch {
      //ignore
    }
  };

  return (
    <Layout>
      <h1 id="primaryPageTitle">Dev Tools</h1>
      <div className={styles.userToken}>
        <strong>{user.userName}</strong>
        <div>Token Expiration: {Helpers.toShortDateTime(user.expiresAt)}</div>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            void refreshToken();
          }}>
          Refresh Token
        </a>
      </div>
      <div className="d-flex flex-wrap justify-content-lg-start justify-content-evenly">
        <TileLink text="API Tester" target="/dev-tools/api" fontAwesomeIcon={faBolt} />
        <TileLink
          text="State Viewer"
          target="/dev-tools/state-viewer"
          fontAwesomeIcon={faFileWaveform}
        />
        <TileLink text="Style Guide" target="/dev-tools/style-guide" fontAwesomeIcon={faPalette} />
      </div>
    </Layout>
  );
};
